import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(value: string[], search: string): any {
    if(!search) return value;
    return value.filter((z) => z.toLowerCase().includes(search.toLowerCase()));
  }

}
